import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  InputNumber,
  Input,
  Typography,
  Space,
  message,
  Select
} from 'antd';
import { SaveOutlined, DollarOutlined, } from '@ant-design/icons';
import {
  ButtonItem,
  SelectItem,
  SwitchItem
} from '../../../Components/Items';
import axios from 'axios';

const { Text } = Typography;
const { Option } = Select;

class ModalIngresoCaja extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monto: 0,
      descripcion: '',
      otrosIngresos: false,
      bancoId: null,
      loading: false,
      todasBancos: [],
      objetoBancos: null,
      permitirOtrosIngresos: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarTodo();
    }
  }

  consultarTodo = () => {
    //Traer las cajas chicas de ingresos para mostrar en el select
    this.setState({ loading: true });
    axios.post(
      'cajas/consultarCajasChicasIngresos',
      {
        sesionId: this.props.sesionId,
        empresaId: this.props.empresaId,
      },
      {
        headers: this.props.headersToken,
      }
    ).then((res) => {
      this.setState({ loading: false });
      if (res.data.success === 2) {
        this.setState({
          todasBancos: res.data.bancos,
          objetoBancos: res.data.bancos.map((banco) => (
            <Option key={banco._id} value={banco._id}>
              {banco.nombre + (banco.descripcion ? (' - ' + banco.descripcion) : '')}
            </Option>
          )),
          permitirOtrosIngresos: res.data.permitirOtrosIngresos,
        })
      } else {
        message.error(res.data.message ? res.data.message : 'Error al consultar las cajas chicas de ingresos');
      }
    }).catch((error) => {
      this.setState({ loading: false });
      console.error('Error al consultar las cajas chicas de ingresos:', error);
      message.error('Error al consultar las cajas chicas de ingresos');
    }).finally(() => {
      this.setState({ loading: false });
    })
  }

  handleGuardar = async () => {
    const { monto, descripcion, otrosIngresos, bancoId } = this.state;

    if (monto <= 0) {
      message.warning('El monto debe ser mayor a cero.');
      return;
    }

    if (!descripcion.trim()) {
      message.warning('La descripción es obligatoria.');
      return;
    }

    if (!otrosIngresos && !bancoId) {
      message.warning('Debe seleccionar una cuenta de ingreso.');
      return;
    }

    this.setState({ loading: true });

    try {
      const res = await axios.post(
        'cajas/guardarIngreso',
        {
          montoIngreso: monto,
          descripcion,
          otrosIngresos: otrosIngresos,
          bancoId: bancoId,
          sesionId: this.props.sesionId, // Asumiendo que recibes sesionId como prop
          empresaId: this.props.empresaId,
        },
        {
          headers: this.props.headersToken, // Asumiendo que tienes headersToken en props
        }
      );

      if (res.data.success === 2) {
        message.success('Ingreso guardado correctamente');
        this.setState({ monto: 0, descripcion: '', bancoId: null, otrosIngresos: false });
        this.props.onCancel(); // Cerrar modal
      } else {
        message.error(res.data.message ? res.data.message : 'Error al guardar el ingreso: ');
      }

      // Simulando éxito
    } catch (error) {
      console.error('Error al guardar el ingreso:', error);
      message.error('Error al guardar el ingreso');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    if (this.state.loading) return;
    this.props.onCancel();
  };

  render() {
    const { visible } = this.props;
    const { monto, descripcion, loading, objetoBancos, permitirOtrosIngresos, otrosIngresos, bancoId } = this.state;

    return (
      <Modal
        title={
          <Space>
            <DollarOutlined style={{ color: '#00b5e2' }} />
            <span>Ingreso de Caja</span>
          </Space>
        }
        visible={visible}
        onCancel={this.handleCancel}
        footer={null}
        centered
        closable={!loading}
        maskClosable={!loading}
      >
        <Row gutter={[16, 16]}>
          {permitirOtrosIngresos && (
            <>
              <Col span={12}>
                <Text strong>Otros Ingresos:</Text>
              </Col>
              <Col span={12}>
                <SwitchItem
                  value={otrosIngresos}
                  onChange={(value) => this.setState({ otrosIngresos: value })}
                  disabled={loading}
                />
              </Col>
            </>
          )}
          {!otrosIngresos && (
            <Col span={24}>
              <Text strong>Cuenta Ingreso:</Text>
              <SelectItem
                value={bancoId}
                onChange={(value) => this.setState({ bancoId: value })}
                style={{ width: '100%' }}
                disabled={loading}
              >
                {objetoBancos}
              </SelectItem>
            </Col>
          )}
          <Col span={24}>
            <Text strong>Monto a ingresar:</Text>
            <InputNumber
              value={monto}
              onChange={(value) => this.setState({ monto: value || 0 })}
              style={{ width: '100%' }}
              min={0}
              precision={2}
              disabled={loading}
            />
          </Col>
          <Col span={24}>
            <Text strong>Descripción:</Text>
            <Input.TextArea
              value={descripcion}
              onChange={(e) => this.setState({ descripcion: e.target.value })}
              rows={3}
              disabled={loading}
            />
          </Col>
        </Row>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <Space>
            <ButtonItem
              type="primary"
              icon={<SaveOutlined />}
              onClick={this.handleGuardar}
              loading={loading}
              style={{
                backgroundColor: '#00b5e2',
                borderColor: '#00b5e2',
                height: '40px',
                paddingLeft: '24px',
                paddingRight: '24px',
              }}
            >
              {loading ? 'Guardando...' : 'Guardar Ingreso'}
            </ButtonItem>
            <ButtonItem
              onClick={this.handleCancel}
              disabled={loading}
              rojo
              style={{ height: '40px', paddingLeft: '24px', paddingRight: '24px' }}
            >
              Cancelar
            </ButtonItem>
          </Space>
        </div>
      </Modal>
    );
  }
}

export default ModalIngresoCaja;
